<h2 class="default-dialog-header" mat-dialog-title class="default-dialog-header m-b-1">
	<span fxFlex>Select Project Type</span>
	<span fxFlex fxLayoutAlign="end center">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content font-size-12 m-t-4">
	<div fxLayout="row" fxLayoutAlign="left center">
		<form (keydown.enter)="$event.preventDefault()"  [formGroup]="projectTypeDetails">
			<mat-radio-group formControlName="type" fxFlex>
				<div *ngFor="let projectType of projectTypes | keyvalue : sortProjects; let isLast = last">
					<mat-radio-button
							class="font-size-12 m-t-1"
							[ngClass]="{'m-b-1': isLast}"
							color="primary"
							value="{{ projectType.value.value }}"
							> {{ projectType.value.label }}
					</mat-radio-button>
				</div>
			</mat-radio-group>
		</form>
	</div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action" fxLayoutGap="1rem">
	<div fxFlex fxLayoutAlign="end center" fxLayoutGap="1rem">
		<span (click)="closeDialog(null)" class="link">Cancel</span>
		<button
			(click)="createProject()"
			[disabled]="projectTypeDetails.invalid"
			color="primary"
			mat-raised-button
		>
			Next
		</button>
	</div>
</mat-dialog-actions>
